import { render, staticRenderFns } from "./NewTabs.vue?vue&type=template&id=f10ef28e&scoped=true"
import script from "./NewTabs.vue?vue&type=script&lang=js"
export * from "./NewTabs.vue?vue&type=script&lang=js"
import style0 from "./NewTabs.vue?vue&type=style&index=0&id=f10ef28e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10ef28e",
  null
  
)

export default component.exports